import httpClient from './httpClient';

const MIME_FALLBACKS = {
  md: 'text/markdown',
  markdown: 'text/markdown'
};

export async function parseFiles(files, options = {}) {
  const formData = new FormData();

  for (const file of files) {
    const mime =
      file.type ||
      MIME_FALLBACKS[
        file.name
          .split('.')
          .pop()
          .toLowerCase()
      ] ||
      'application/octet-stream';
    const blob = new Blob([file], { type: mime });
    formData.append('files', blob, file.name);
  }

  for (const [key, value] of Object.entries(options)) {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  }

  return httpClient.post('/api/filesmanager/parse', formData, false, { json: false });
}

export function getConversionResults(jobId, { intervalMs = 1000, timeoutMs = 120000 } = {}) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    async function poll() {
      try {
        const result = await httpClient.get(`/api/filesmanager/parse/${jobId}`);

        if (result && result.status === 'Processing') {
          if (Date.now() - start >= timeoutMs) {
            reject(new Error(`File conversion timed out after ${timeoutMs}ms`));
            return;
          }
          setTimeout(poll, intervalMs);
        } else {
          resolve(result);
        }
      } catch (err) {
        reject(err);
      }
    }

    poll();
  });
}

export async function convertFiles(files, parsingOptions = {}, pollOptions = {}) {
  const { jobId } = await parseFiles(files, parsingOptions);
  return getConversionResults(jobId, pollOptions);
}
